import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { MEDIA_MANIFEST, PLACEHOLDERS } from "@/content/media";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MediaContext = createContext({ slots: {}, loaded: false });

export const MediaProvider = ({ children }) => {
  const [slots, setSlots] = useState({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    axios.get(`${API}/media`).then((r) => setSlots(r.data.slots || {})).catch(() => {}).finally(() => setLoaded(true));
  }, []);
  const value = useMemo(() => ({ slots, loaded }), [slots, loaded]);
  return <MediaContext.Provider value={value}>{children}</MediaContext.Provider>;
};

const withUrl = (item) => ({ ...item, src: `${process.env.REACT_APP_BACKEND_URL}${item.url}`, poster: item.poster_id ? `${process.env.REACT_APP_BACKEND_URL}/api/media/${item.poster_id}/file` : undefined });

// Returns real media for a slot (admin uploads > manifest), padded with labelled placeholders up to `min`.
export const useMediaSlots = () => useContext(MediaContext);

export const useMedia = (slot, min = 0) => {
  const { slots, loaded } = useContext(MediaContext);
  return useMemo(() => {
    const uploaded = (slots[slot] || []).map(withUrl);
    const manifest = (MEDIA_MANIFEST[slot] || []).map((m, i) => ({ id: `manifest-${slot}-${i}`, ...m }));
    const real = uploaded.length ? uploaded : manifest;
    const placeholders = PLACEHOLDERS[slot] || [];
    const need = (min === 0 ? 0 : Math.max(min, placeholders.length)) - real.length;
    const fill = need > 0 ? placeholders.slice(real.length).map((p, i) => ({ id: `ph-${slot}-${i}`, placeholder: true, ...p })) : [];
    return { items: [...real, ...fill], loaded, hasReal: real.length > 0 };
  }, [slots, slot, min, loaded]);
};
